import { LinkButton, Row } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const PaddingContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: ${({ theme }) => theme.spacing(6)};
	grid-column: span 2;
	gap: ${({ theme }) => theme.spacing(4)};
`;

const ThankYouImage = styled.img`
	width: 450px;
	height: 450px;
`;

const ThankYou = styled.div`
	font-size: 2rem;
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

export const EventOffboardingThankYouPage: FC = () => {
	const { t } = useTranslation();
	return (
		<PaddingContainer>
			<ThankYouImage src="/thank-you.svg" />
			<ThankYou>{t("Thank you!")}</ThankYou>
			<Row $columnGap={2}>
				<LinkButton to="../../.." replace>
					{t("Back to event detail page")}
				</LinkButton>
				<LinkButton color="primary" to="../../../.." replace>
					{t("To event list")}
				</LinkButton>
			</Row>
		</PaddingContainer>
	);
};
